import React from 'react';
import { useSEO } from '../../../hooks/useSEO';
import { LANDING_CONTENT as C } from './content';
import WhatsAppCTA from './components/WhatsAppCTA';
import SectionPain from './components/SectionPain';
import SectionSolution from './components/SectionSolution';
import SectionProof from './components/SectionProof';
import SectionBenefits from './components/SectionBenefits';
import SectionDifferentials from './components/SectionDifferentials';
import SectionFAQ from './components/SectionFAQ';
import './SoftwareForDistributorsLanding.scss';

const SoftwareForDistributorsLanding: React.FC = () => {
  useSEO({
    title: C.seo.title,
    description: C.seo.description,
    canonical: '/software-para-distribuidoras',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: '77Gestão — Software para Distribuidoras',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      url: 'https://77gestao.com.br/software-para-distribuidoras',
      description: C.seo.description,
    },
  });

  return (
    <div className="software-for-distributors-landing">
      <section className="lp-hero" aria-labelledby="hero-title">
        <div className="lp-container">
          <span className="lp-kicker">{C.hero.kicker}</span>
          <div className="lp-hero-title-wrapper">
            <h1 className="lp-title" id="hero-title">{C.hero.title}</h1>
            <div className="lp-hero-icon">
              <i className="fa-solid fa-bolt-lightning" aria-hidden="true" />
            </div>
          </div>
          <p className="lp-subtitle">{C.hero.subtitle}</p>
          <WhatsAppCTA message={C.hero.ctaMessage} id="cta-hero">
            {C.hero.cta}
          </WhatsAppCTA>
          <p className="lp-meta">{C.hero.urgency}</p>
        </div>
      </section>

      <SectionPain {...C.pain} />
      <SectionSolution {...C.solution} />
      <SectionProof {...C.proof} />
      <SectionBenefits {...C.benefits} />
      <SectionDifferentials
        {...C.differentials}
        cta={{ text: 'Falar com a equipe', message: C.hero.ctaMessage }}
      />
      <SectionFAQ {...C.faq} />

      <section className="lp-cta-final" id="schedule-demo" aria-labelledby="cta-final-title">
        <div className="lp-container">
          <h2 id="cta-final-title">{C.ctaFinal.title}</h2>
          <p>{C.ctaFinal.subtitle}</p>
          <WhatsAppCTA message={C.ctaFinal.ctaMessage} className="lp-btn lp-btn--final" id="cta-final">
            {C.ctaFinal.cta}
          </WhatsAppCTA>
        </div>
      </section>
    </div>
  );
};

export default SoftwareForDistributorsLanding;
